Ext.define('SA.OrPredicate', {
    extend: 'SA.AbstractPredicate',

    constructor(predicates) {
        this.predicates = predicates;
    },

    and(otherPredicate) {
        return SA.Predicate.and([this, otherPredicate]);
    },

    serialize() {
        return ['or', ...this.predicates.map(predicate => predicate.serialize())];
    }
});